import React from 'react';
import ButtonComponent from '../../components/button/button';
import { useNavigate } from 'react-router-dom';
import { Dayjs } from 'dayjs';
import { getSearchResults } from '../../features/search/service/search-service';
import DatePickerComponent from '../../components/input/input-date';
import { ExportDelayData } from './mapper/delay-mapper';
import { getMe } from '../../features/search/service/user-service';
import { User } from '../../shared/types/user';

const Reports = () => {
    const navigate = useNavigate();
    const [initialDate, setInitialDate] = React.useState<Dayjs | null>(null);
    const [finalDate, setFinalDate] = React.useState<Dayjs | null>(null);
    const [isLoading, setIsLoading] = React.useState(false);
    const [user, setUser] = React.useState<User | null>(null);

    React.useEffect(() => {
        const fetchUser = async () => {
            try {
                const userData = await getMe();
                setUser(userData);
            } catch (error) {
                console.error('❌ Erro ao buscar dados do usuário:', error);
                alert('Erro ao carregar informações do usuário. Por favor, faça login novamente.');
            }
        };
        fetchUser();
    }, []);

    const handleDownloadReport = async () => {
        if (!user?.company?.id && !user?.companyId) {
            console.error('❌ Usuário sem empresa associada');
            alert('Usuário sem empresa associada. Entre em contato com o administrador.');
            return;
        }

        try {
            setIsLoading(true);

            const companyId = user.company?.id || user.companyId;
            
            const queryParams = new URLSearchParams();
            queryParams.append('companyId', companyId!);
            
            if (initialDate) {
                const formattedStart = initialDate.format('YYYY-MM-DD');
                queryParams.append('startDate', formattedStart);
            }
            
            if (finalDate) {
                const formattedEnd = finalDate.format('YYYY-MM-DD');
                queryParams.append('endDate', formattedEnd);
            }
            
            const response = await getSearchResults(queryParams);
            
            if (response.data && response.data.length > 0) {
                
                const companyName = user.company?.name || 'empresa';
                const safeCompanyName = companyName.replace(/\s+/g, '_').toLowerCase();
                const fileName = `relatorio_delay_discounting_${safeCompanyName}`;
                
                ExportDelayData(response, fileName);
                
                alert(`✅ Relatório gerado com sucesso!\n${response.data.length} registro(s) encontrado(s).`);
            } else {
                alert('Nenhum registro encontrado para o período selecionado.\n\nVerifique:\n- Se existem dados cadastrados para sua empresa\n- Se o período selecionado está correto');
            }
        } catch (error) {
            alert('Erro ao gerar o relatório. Por favor, tente novamente.');
        } finally {
            setIsLoading(false);
        }
    };
    
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
            <img src="../../../assets/logo-inteira.png" alt="Logo delay discounting"  className="logo" style={{ width: '300px', height: '200px' }}/>
            <h1 
                style={{
                    textAlign: 'center', 
                    fontSize: '2rem', 
                    fontFamily: 'Roboto, sans-serif', 
                    color: '#3a8d8e',
                    margin: '1rem 0',
                }}>
                Relatórios
            </h1>
            <h2 style={{ textAlign: 'center', fontSize: '1.5rem', fontFamily: 'Roboto, sans-serif', color: '#3a8d8e', margin: '1rem 0' }}>
                Selecione o período
            </h2>

            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', margin: '1rem' }}>
                <DatePickerComponent 
                    label="Data Inicial"
                    value={initialDate}
                    onChange={(event: Dayjs | null) => setInitialDate(event)}
                    styles={{
                        margin: '0 1rem',
                    }}
                />
                
                <DatePickerComponent 
                    label="Data Final"
                    value={finalDate}
                    onChange={(event: Dayjs | null) => setFinalDate(event)}
                />
            </div>

            <ButtonComponent 
                label={isLoading ? "Gerando..." : "Baixar Relatório"} 
                onClick={() => handleDownloadReport()}
                props={{
                    disabled: !initialDate || isLoading || !user,
                }}
            />
            <ButtonComponent 
                isReturnButton={true} 
                label="Voltar ao início" 
                onClick={() => navigate('/home')} 
                props={{
                    disabled: isLoading,
                }}
            />
        </div>
    );
}

export default Reports;